import {
  ContentColumn,
  ContentContainer,
  OverViewSplash,
  OverviewTitle,
  SplashButton,
  SplashContainer,
  SplashContentDescription,
  SplashImage,
} from './style'

import React from 'react'
import SPLASH_IMAGE from 'assets/splash-light.png'
import SPLASH_IMAGE_DARK from 'assets/splash-dark.png'
import { useThemeBasedImage } from 'hooks'

/**
 * This is the first section of the overview page (splash)
 * @param loading
 * @returns
 */
const SplashComponent: React.FC = () => {
  const splashImage = useThemeBasedImage(SPLASH_IMAGE, SPLASH_IMAGE_DARK)

  const scrollToElement = () => {
    const contentElement = document.getElementById('content')
    if (contentElement) {
      contentElement.scrollIntoView({ behavior: 'smooth' })
    }
  }

  /**
   * IT: Scrolls to the content #content
   * WHEN: The url contains #content and the component is mounted
   */
  React.useEffect(() => {
    if (window.location.hash === '#content') {
      scrollToElement()
    }
  }, [])

  return (
    <OverViewSplash>
      <SplashContainer>
        <ContentContainer>
          <ContentColumn>
            <OverviewTitle>Invest in crypto&apos;s biggest trends</OverviewTitle>
            <SplashContentDescription>
              Phuture&apos;s leading index products are the best way to get diversified exposure to
              the crypto markets
            </SplashContentDescription>
            <SplashButton buttonType={'primary'} onClick={scrollToElement}>
              Buy now
            </SplashButton>
          </ContentColumn>
          <ContentColumn>
            <SplashImage src={splashImage} />
          </ContentColumn>
        </ContentContainer>
      </SplashContainer>
    </OverViewSplash>
  )
}
export default SplashComponent
